import React, { memo, useRef } from 'react';

import { TitleDivider, Divider } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

import ProductCarousel from './components/ProductCarousel';
import ProductInfo from './components/ProductInfo';
import ProductDetailLoader from './components/ProductDetailLoader';
import ProductDetailTabs from './components/ProductDetailTabs';
import SyncStatusBadge from 'containers/components/SyncStatusBadge';

import './styles.scss';

const ProductsDetail = memo(({ data, entity, loading }) => {
    const domDetailInfo = useRef(null);
    return (
        <div className="fm-products-detail">
            <TitleDivider overrides={{ Text: { medium: true } }}>
                <div className="fm-products-detail__title-container">
                    {getLiteral('label_product_detail')}
                    <SyncStatusBadge entity={entity} isDetail />
                </div>
            </TitleDivider>
            <div className="fm-products-detail__content" ref={domDetailInfo}>
                {loading && (
                    <ProductDetailLoader
                        width={domDetailInfo.current?.offsetWidth - 48}
                        height={domDetailInfo.current?.offsetHeight}
                    />
                )}
                {!loading && (
                    <>
                        <div className="fm-products-detail__top-content">
                            <ProductCarousel ids={data?.productImageList?.long} />
                            <ProductInfo data={data} />
                        </div>
                        <Divider className="fm-products-detail__divider" />
                        <ProductDetailTabs data={data} />
                    </>
                )}
            </div>
        </div>
    );
});

export default ProductsDetail;
